// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2ANdg","box":"WorkspacesBox_box__1wo50","node":"WorkspacesBox_node__xUM97"};